/**
 * Unsaved edits in Server settings. An editor (a role, a channel) says while
 * it holds some; picking another item, another tab, "View server as role",
 * Escape and the close button then wait for Save or Reset, as Discord holds
 * you on its save bar.
 */
import { useEffect } from 'react';
import { tr } from '../i18n';
import { toast } from '../ui/overlay';

const holders = new Set<string>();

export function hasUnsaved(): boolean {
  return holders.size > 0;
}

/** True (and says so) when there are unsaved edits: the caller then stays where it is. */
export function holdForUnsaved(): boolean {
  if (!holders.size) return false;
  toast(tr().t('roles.saveFirst'), { tone: 'danger', icon: 'alert' });
  return true;
}

/** Registers `key` as holding unsaved edits while `dirty` (and while mounted). */
export function useUnsaved(key: string, dirty: boolean): void {
  useEffect(() => {
    if (!dirty) return;
    holders.add(key);
    return () => {
      holders.delete(key);
    };
  }, [key, dirty]);
}
